var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExploreVesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0,.st1,.st2,.st3,.st4,.st5{fill:none;stroke:#fff;stroke-width:6;stroke-linecap:round}.st1{clip-path:url(#SVGID_00000052805003814368778930000015940479215427057558_)}.st2{clip-path:url(#SVGID_00000016797306134579463360000000959190277756999075_)}.st3{clip-path:url(#SVGID_00000093173701244437661910000001040617851841403285_)}.st4{clip-path:url(#SVGID_00000060746272677513804380000016437948070224475319_)}.st5{clip-path:url(#SVGID_00000044166058026351378400000016587704400503711160_)}.st6,.st7{clip-path:url(#SVGID_00000095305637022152391430000005084498427721082780_)}.st6{fill:none;stroke:#fff;stroke-width:6;stroke-linecap:round}.st7{fill:#16171c}.st8,.st9{clip-path:url(#SVGID_00000164516016601794170380000014058403081330845834_)}.st8{fill:none;stroke:#fff;stroke-width:6;stroke-linecap:round}.st9{fill:#fff}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000170272235389178408250000013622618282672062346_",
    d: "M6.7 7.3h85.7V93H6.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145754984103956429810000008015458466203993995_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170272235389178408250000013622618282672062346_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000145754984103956429810000008015458466203993995_)",
      fill: "none",
      stroke: "#fff",
      strokeWidth: 6,
      strokeLinecap: "round"
    },
    d: "M17.2 34c-8.9 8.9-8.9 23.4 0 32.3l16.2 16.2c8.9 8.9 23.4 8.9 32.3 0l16.2-16.2c8.9-8.9 8.9-23.4 0-32.3L65.7 17.8c-8.9-8.9-23.4-8.9-32.3 0L17.2 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000145754984103956429810000008015458466203993995_)",
      fill: "#fff"
    },
    d: "M51.2 35.1c-.3-.6-.9-1-1.6-1-.7 0-1.3.4-1.6 1l-3.6 7.4-8 1.2c-.7.1-1.2.6-1.4 1.2-.2.6 0 1.4.4 1.8l5.8 5.8-1.4 8.2c-.1.7.2 1.4.7 1.8.6.4 1.3.4 1.9.1l7.2-3.8 7.2 3.8c.6.3 1.3.3 1.9-.1.6-.4.8-1.1.7-1.8L58 52.5l5.8-5.8c.5-.5.7-1.2.4-1.8-.2-.6-.8-1.1-1.4-1.2l-8-1.2-3.6-7.4z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreVesting);
export default __webpack_public_path__ + "static/media/exploreVesting.82aaea340ec8fdd67e2c3b632044a536.svg";
export { ForwardRef as ReactComponent };